module.exports = __webpack_public_path__ + "static/media/nos_acerca.1b5fa2f7.png";